import { CorrespondenceRequestCategoryDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCorrespondenceRequestCategory = createAction(
  '[CorrespondenceRequestCategory] Load CorrespondenceRequestCategory'
);

export const loadCorrespondenceRequestCategorySuccess = createAction(
  '[CorrespondenceRequestCategory] Load CorrespondenceRequestCategory Success',
  props<{ correspondenceRequestCategory: CorrespondenceRequestCategoryDto[] }>()
);

export const loadCorrespondenceRequestCategoryFailure = createAction(
  '[CorrespondenceRequestCategory] Load CorrespondenceRequestCategory Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCorrespondenceRequestCategory = createAction(
  '[CorrespondenceRequestCategory] Add CorrespondenceRequestCategory',
  props<{
    newCorrespondenceRequestCategory: CorrespondenceRequestCategoryDto[];
  }>()
);

export const addCorrespondenceRequestCategorySuccess = createAction(
  '[CorrespondenceRequestCategory] Add CorrespondenceRequestCategory Success',
  props<{
    newCorrespondenceRequestCategory: CorrespondenceRequestCategoryDto[];
  }>()
);

export const addCorrespondenceRequestCategoryFailure = createAction(
  '[CorrespondenceRequestCategory] Add CorrespondenceRequestCategory Failure',
  props<{ error: any }>()
);

/**
 * Update CorrespondenceRequestCategory Collection Actions
 */
export const updateCorrespondenceRequestCategory = createAction(
  '[CorrespondenceRequestCategory] Update CorrespondenceRequestCategory',
  props<{
    updateCorrespondenceRequestCategory: CorrespondenceRequestCategoryDto[];
  }>()
);

export const updateCorrespondenceRequestCategorySuccess = createAction(
  '[CorrespondenceRequestCategory] Update CorrespondenceRequestCategory Success',
  props<{
    updateCorrespondenceRequestCategory: CorrespondenceRequestCategoryDto[];
  }>()
);

export const updateCorrespondenceRequestCategoryFailure = createAction(
  '[CorrespondenceRequestCategory] Update CorrespondenceRequestCategory Failure',
  props<{ error: any }>()
);

/**
 * Remove CorrespondenceRequestCategory Collection Actions
 */
export const removeCorrespondenceRequestCategory = createAction(
  '[CorrespondenceRequestCategory] Remove CorrespondenceRequestCategory',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceRequestCategorySuccess = createAction(
  '[CorrespondenceRequestCategory] Remove CorrespondenceRequestCategory Success',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceRequestCategoryFailure = createAction(
  '[CorrespondenceRequestCategory] Remove CorrespondenceRequestCategory Failure',
  props<{ error: any }>()
);
